interface Instant {
  nanos: number;
  seconds: number;
}

export interface LocalDate {
  day: number;
  month: number;
  year: number;
}

export const monthsAbbreviated = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDateAsMonthYear = (year: number, month: number) => `${monthsAbbreviated[month - 1]}, ${year}`;

export const formatDateAsYYYYMM = (year: number, month: number) => {
  return `${year}${month.toString().padStart(2, '0')}`;
};

export const formatJavaInstantToLocaleString = (instant: Instant) => {
  if (!instant) {
    return '-';
  }
  return new Date(instant.seconds * 1000).toLocaleString();
};

export const formatJavaInstantToDate = (instant?: Instant | null) => {
  if (!instant) {
    return '-';
  }
  return new Date(instant.seconds * 1000).toLocaleDateString('en-US', { timeZone: 'America/New_York' });
};

export const formatJavaLocalDate = (date: LocalDate) => {
  return new Date(date.year, date.month, date.day).toLocaleDateString('en-US', { timeZone: 'America/New_York' });
};

export const getCurrentDate = (format = 'MM/DD/YYYY', timeZone = 'America/New_York') => {
  // const date = new Date();

  const formattedDate = new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone,
  });

  const [month, day, year] = formattedDate.split(/[/\-.,]/);

  switch (format) {
    case 'MM/DD/YYYY':
      return `${month}/${day}/${year}`;
    case 'DD/MM/YYYY':
      return `${day}/${month}/${year}`;
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    default:
      return formattedDate;
  }
};

// format date to MM/DD/YYYY
export const formatDateToMMDDYYYY = (date: Date) => {
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};
